class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener('cartdrawer:opened', () => {
      this.bindShake();
    });
  }

  bindShake() {
    const proceedButton = this.drawer?.querySelector('#cre8or-checkout-btn');
    if (!proceedButton) return;

    proceedButton.addEventListener('click', () => {
      if (!proceedButton.classList.contains('is-disabled')) return;

      const checkbox = this.drawer.querySelector('#cre8or-terms-agree');
      if (!checkbox) return;

      const target = checkbox.parentElement.querySelector('.cre8or-shake-parent');
      if (!target) return;

      // SHAKE
      let i = 0;
      const positions = [-4, 4, -3, 3, -2, 2, 0];

      const shake = setInterval(() => {
        target.style.transform = `translateX(${positions[i]}px)`;
        i++;

        if (i >= positions.length) {
          clearInterval(shake);
          target.style.transform = '';
        }
      }, 50);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
    this.bindShake();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
